import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Hero() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20comic%20book%20illustration%20collage%20background%2C%20colorful%20manga%20and%20manhwa%20art%20style%20panels%20arranged%20artistically%2C%20warm%20orange%20coral%20and%20amber%20tones%2C%20Japanese%20and%20Korean%20comic%20characters%20in%20dynamic%20poses%2C%20abstract%20geometric%20shapes%2C%20modern%20digital%20art%2C%20creative%20layout%2C%20white%20empty%20center%20area%20for%20text%20placement%2C%20bright%20and%20energetic%20atmosphere&width=1600&height=800&seq=hero-bg-comic&orientation=landscape"
        alt="香蕉文化漫画网 - 海量漫画资源"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          <span className="text-primary-400">香蕉文化</span>漫画网
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-3 max-w-2xl mx-auto leading-relaxed">
          下拉式、翻页与弹窗多种阅读模式，流畅免费看全集热门漫画
        </p>
        <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
          精品韩漫日漫国漫资源 · 海量正版漫画 · 极致在线阅读体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            立即阅读
          </Link>
          <Link
            to="/category/korean"
            className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white px-8 py-3 rounded-full text-sm font-semibold transition-all border border-white/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line"></i>
            热门韩漫
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2">
          {categories.slice(1, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="inline-flex items-center gap-1.5 bg-white/10 hover:bg-white/20 text-white/90 px-4 py-2 rounded-full text-xs font-medium transition-all border border-white/10 whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-white/70 hover:text-white text-xs px-2 py-2 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}